// @ts-nocheck
/**
 * AgStoreOrderGrid — Order By Store grid wrapper
 *
 * Thin wrapper around BaseOrderGrid with Store-page-specific configuration:
 * SKU-centric columns, per-row shelf qty, single selection, expanded metrics bar.
 */
import React from 'react';
import BaseOrderGrid, { MetricConfig } from 'pages/orderBySku/components/baseOrderGrid';
import { STORE_COL_CONFIG, STORE_GROUP_OPTIONS } from '../constants';

interface Props {
	data: Record<string, any>[];
	onOrderQtyChange?: (rowIdx: number, skuId: string, newQty: number) => void;
	groupableColumns?: { key: string; label: string }[];
	storeLabel?: string;
	storeDesc?: string;
	storeTotalOrdered?: number;
}

const STORE_METRICS_CONFIG: MetricConfig[] = [
	{ label: 'SKUS', valueFn: (d) => new Set(d.map((r) => r.SKU).filter(Boolean)).size, color: '#7b1fa2' },
	{ label: 'WAREHOUSES', valueFn: (d) => new Set(d.map((r) => r.Warehouse).filter(Boolean)).size, color: '#6a1b9a' },
	{ label: 'TOTAL OH', valueFn: (d) => d.reduce((s, r) => s + Number(r.OnHand || 0), 0), color: '#333' },
	{ label: 'SUGGESTED', valueFn: (d) => d.reduce((s, r) => s + Number(r.SuggestedQty || 0), 0), color: '#333' },
	{
		label: 'AVAILABLE',
		valueFn: (d) => d.reduce((s, r) => s + Number(r.CurrentAvailableQty || 0), 0),
		color: '#333',
	},
	{ label: 'ORDER QTY', valueFn: (d) => d.reduce((s, r) => s + Number(r.OrderQty || 0), 0), color: '#2e7d32' },
];

const STORE_DEFAULT_COL_DEF_OVERRIDES = { filter: true, enableRowGroup: true };

const AgStoreOrderGrid: React.FC<Props> = ({
	data,
	onOrderQtyChange,
	groupableColumns,
	storeLabel,
	storeDesc,
	storeTotalOrdered,
}) => {
	return (
		<BaseOrderGrid
			data={data}
			colConfig={STORE_COL_CONFIG}
			groupOptions={STORE_GROUP_OPTIONS}
			onOrderQtyChange={onOrderQtyChange}
			entityIdField="SKU"
			shelfQtyField="QtyPerShelf"
			selectionMode="single"
			metricsConfig={STORE_METRICS_CONFIG}
			groupableColumns={groupableColumns}
			defaultColDefOverrides={STORE_DEFAULT_COL_DEF_OVERRIDES}
		/>
	);
};

export default AgStoreOrderGrid;
